export enum LegalAcknowledgementType {
  MY_TERMS_OF_USE = "my-terms-of-use",
  MY_PRIVACY_POLICY = "my-privacy-policy",
  MY_INVESTOR_AGREEMENT = "my-investor-agreement",
  MY_RISK_DISCLOSURES = "my-risk-disclosures",
  MY_RISK_WARNING_DISCLAIMERS = "my-risk-warning-disclaimers",
  MY_DISCLOSURE_STATEMENT = "my-disclosure-statement",
  SG_TERMS_OF_USE = "sg-terms-of-use",
  SG_PRIVACY_POLICY = "sg-privacy-policy",
  SG_RISK_DISCLOSURES = "sg-risk-disclosures",
  SG_INVESTOR_RISK_DISCLOSURES = "sg-investor-risk-disclosures",
  SG_RISK_WARNING_DISCLAIMERS = "sg-risk-warning-disclaimers",
  SG_BROKERAGE_AND_CUSTODY_TNC = "sg-brokerage-and-custody-tnc",
  SG_BROKERAGE_TNC = "sg-brokerage-tnc",
  SG_CUSTODY_TNC = "sg-custody-tnc",
  SG_DISCORD_TNC = "sg-discord-tnc",
  SG_MMF_TNC = "sg-mmf-tnc",
}

export type LegalAcknowledgementStatus = {
  type: string;
  version: string;
  trader_id: string;
  content: string;
  legal_tnc_id: string;
  legal_tnc_created_at: string;
  acknowledged: boolean | null;
  ack_id: string | null;
  url: string;
  title: string;
};

export type TnC = Pick<LegalAcknowledgementStatus, "type" | "title" | "url">;

export type TnCWithContent = TnC &
  Pick<LegalAcknowledgementStatus, "type" | "title" | "url" | "content">;
